import React from "react";
import {renderRichText} from "gatsby-source-contentful/rich-text";

export default function FaqSection(props) {
    return (
        <section key={props.content.id} className="faq-section">
            <div className="container">
                <h2>{props.content.title}</h2>

                <div className="accordion" id="accordion">
                    { props.content.elements.map((element, index) => {
                        return (
                            <div className="accordion-item">
                                <h2 className="accordion-header" id={`faq-${index}`}>
                                    <button className={'accordion-button collapsed'} type="button"
                                            data-bs-toggle="collapse" data-bs-target={`#apps-collapse-${index}`}
                                            aria-expanded={false} aria-controls={`apps-collapse-${index}`}>
                                        {element.question}
                                    </button>
                                </h2>
                                <div id={`apps-collapse-${index}`} className={'accordion-collapse collapse'}
                                     aria-labelledby={`apps-${index}`}
                                     data-bs-parent="#apps-accordion">
                                    <div className="accordion-body">
                                        {renderRichText(element.answer)}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}
